<div class="panel">
    <div class="access">
        Redirecting you to the Auth0 page for Sign Up...
    </div>
</div>  